// extracted by mini-css-extract-plugin
export default {"copyright":"CopyRight_copyright__CJxeq","links-container":"CopyRight_links-container__HYDhg","copy-text":"CopyRight_copy-text__FHJc8","payments":"CopyRight_payments__9SRA4"};